/**
 * Parses a string into a float.
 * @param {string} numberToParse string to be parsed as float
 */
const parseFloatValue = (numberToParse) => {
    return parseFloat(numberToParse).toFixed(2).replace('.', ',')
}

/**
 * Parses a string into a float including a currency symbol
 * @param {any} numberToParse string to be parsed as float currency
 */
const parseFloatCurrency = (numberToParse) => {
    return parseFloat(numberToParse).toFixed(2).replace('.', ',') + "€"
}

export { parseFloatValue, parseFloatCurrency }